module.exports = __webpack_public_path__ + "static/media/c-pressure.7fd136b3.svg";